import React from 'react';
import { ButtonGroup, Button, Spinner } from 'react-bootstrap';
import { statusUpdate } from '../../../API/Service/shopService';
import useToast from '../../../API/GlobalHooks/useToast';

const StatusToggle = ({ isActive = false, id = 0 }) => {
  const showToast = useToast();
  const [active, setActive] = React.useState(isActive);
  const [loading, setLoading] = React.useState(false); // Loading state

  const handleStatusUpdate = async (status) => {
    setLoading(true);
    let data = { id: id, user_status: status ? 1 : 0 };
    
    try {
      const resData = await statusUpdate(data);
      if (resData?.data?.id > 0) {
        setActive(status);
      } else {
        showToast("Something went wrong! Please try again", 'danger');
      }
    } catch (error) {
      showToast("Something went wrong! Please try again", 'danger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ButtonGroup size="sm">
      <Button
        variant={active ? 'success' : 'outline-success'}
        active={active}
        disabled={loading}
        onClick={() => handleStatusUpdate(true)}
      >
        {loading && active && (
          <Spinner animation="border" size="sm" role="status" className="me-2" />
        )}
        Active
      </Button>
      <Button
        variant={!active ? 'danger' : 'outline-danger'}
        active={!active}
        disabled={loading}
        onClick={() => handleStatusUpdate(false)}
      >
        {loading && !active && (
          <Spinner animation="border" size="sm" role="status" className="me-2" />
        )}
        Inactive
      </Button>
    </ButtonGroup>
  );
};

export default StatusToggle;
